import apiSlice from './ApiSlice';

export const UserServiceApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({ 
 
    //Get All User
    getAllUser: builder.query({
        providesTags: ["user"],
        query: (body) => {
          return {
            url: "/admin",
            method: "POST",
            body,
          };
        },
      }),


    // add User
    adduser: builder.mutation({
        invalidatesTags: ["user"],
        query: (body) => ({
          url: `/admin/signup`,
          method: "POST",
          body,
        }),
      }),
       // Edit User
    updateUser: builder.mutation({
        invalidatesTags: ["user"],
        query: ({ body, id }) => {
          return {
            url: `/admin/${id}`,
            method: "PUT",
            body,
          };
        },
      }),
      //Get Single User 
      getSingleUser: builder.query({
        providesTags: ["user"],
        query: ({ id }: { id: string }) => {
          return {
            url: `/admin/${id}`,
            method: "GET",
          };
        },
      }),
       // DELETE
    deleteUser: builder.mutation({
        invalidatesTags: ["user"],
        query: (id) => {
          return {
            url: `/admin/${id}`,
            method: "DELETE",
          };
        },
      }),
  }),
});

export const {useAdduserMutation , useUpdateUserMutation,  useGetSingleUserQuery , useGetAllUserQuery , useDeleteUserMutation  } = UserServiceApi;